<template>
  <div class="father">
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>会员信息</el-breadcrumb-item>
        <el-breadcrumb-item>创建卡类别</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="" style="margin:5px">
      <div style="width:100%;height:auto;padding:0 10px 0 10px;">
        <div style="" class="card-title">
          <div style="display:inline-block;">
            <el-button type="success" @click="createNewActive" plain>创建卡类别</el-button>
            <!-- <el-button type="primary" plain>发放会员卡</el-button> -->
          </div>
          <el-form v-show="true" :inline="true" class="demo-form-inline" style="display:inline-block;"
            @submit.native.prevent>
            <el-form-item label="卡类别名称">
              <el-input placeholder="输入卡类别名称搜索" v-model="search_input"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="search">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table border :header-cell-style="{
          color: '#606266'
        }" max-height="580" ref="multipleTable" :data="cClassData" tooltip-effect="dark" style="width: 100%;">
          <el-table-column fixed align="center" type="index" width="55">
          </el-table-column>
          <el-table-column fixed align="center" label="卡类别名称" prop="classify_name" width="200">
          </el-table-column>

          <el-table-column fixed align="center" prop="classify_no" label="卡类别编号" width="240">
          </el-table-column>
          <el-table-column align="center" prop="supply_balance" label="支持储值" width="240">
          </el-table-column><el-table-column align="center" prop="supply_bonus" label="支持积分" width="240">
          </el-table-column><el-table-column align="center" prop="binds_flag" label="支持转让" width="240">
          </el-table-column>

          <el-table-column align="center" prop="merchant_id" label="店铺id" width="200" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" prop="prerogative" label="特权说明" width="380" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" prop="describe" label="描述" width="300" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" label="店铺logo" width="200">
            <template slot-scope="scope">
              <img :src="scope.row.log_pic_url
                  ? $url + 'media/image/' + scope.row.log_pic_url + '.jpg'
                  : ''
                " class="" style="width:120px;height:120px" alt="" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="背景图片" width="200">
            <template slot-scope="scope">
              <img :src="scope.row.backgroup_pic_url
                  ? $url +
                  'media/image/' +
                  scope.row.backgroup_pic_url +
                  '.jpg'
                  : ''
                " class="" style="width:120px;height:120px" alt="" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <createCard style="margin-top:8px" ref="createCardRef" v-show="true" @closeCreateCard="closeCreateCard">
      <template v-slot:title>
        新建会员卡
      </template>
      <template v-slot:cardForm>
        <ccf ref="cardClassRef"></ccf>
        <!-- <activeForm ref="activeFormRef"></activeForm> -->
      </template>
      <template v-slot:btn_name>
        <el-button type="primary" plain style="margin-left:204px" @click="createCardClass">保存
        </el-button>
      </template>
    </createCard>
  </div>
</template>
<script>
import { classifyQuery } from "@/api/index";
import ccf from "../../components/ccf.vue";
import createCard from "@/components/createCard.vue";
export default {
  components: {
    createCard,
    ccf
  },
  watch: {
    search_input: {
      handler(new_input, old_input) {
        this.search();
      }
    }
  },
  data() {
    return {
      search_input: "",
      // dialogFormVisible: false,
      height: "height:" + (document.body.clientHeight - 450) + "px",
      cClassData: [],
      allCardClass: []
      // multipleSelection: []
    };
  },
  async mounted() {
    const res = await classifyQuery();
    if (res.data.return_code === "FAIL" && res.data.return_msg) {
      this.$message.error(res.data.return_msg);
    } else if (res.data.result_code === "FAIL" && res.data.result_msg) {
      this.$message.error(res.data.result_msg);
    } else if (
      res.data.return_code === "SUCCESS" &&
      res.data.result_code === "SUCCESS"
    ) {
      this.cClassData = res.data.resp_data;
      this.allCardClass = res.data.resp_data;
      for (var i = 0; i < this.cClassData.length; i++) {
        for (let key in this.cClassData[i]) {
          if (
            key === "binds_flag" ||
            key === "supply_balance" ||
            key === "supply_bonus"
          ) {
            // console.log("i："+i+"key："+key)
            if (this.cClassData[i][key] === "0") {
              this.cClassData[i][key] = "否";
            } else {
              this.cClassData[i][key] = "是";
            }
          }
        }
      }
      console.log(this.cClassData);
    }
  },
  methods: {
    async stopActive(data) {
      // console.log(data);
      //const res = await terminationActive(data.activity_id);
    },
    createNewActive() {
      this.$refs.createCardRef.openBox();
    },
    createCardClass() {
      this.$refs.cardClassRef.createCardClass();
    },
    search() {
      /* let active_list = [];
      const arr = this.allActive;
      for (var x = 0; x < arr.length; x++) {
        if (arr[x].classify_name.indexOf(this.search_input) >= 0) {
          active_list.push(arr[x]);
        }
      }
      this.activeData = [];
      this.activeData = active_list; */
    },
    closeCreateCard(res) { }
  }
};
</script>

<style scoped>
.father {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 99%;
  background-color: #fff;
  margin: 0px;
  padding: 0px;
}

.el-breadcrumb {
  width: 50%;
  height: 25px;
  margin: 0px;
  padding: 5px 0 0 10px;
}

.card-title {
  height: 50px;
  display: flex;
  justify-content: space-between;
}

.dialog-footer {
  width: 100%;
  text-align: left;
  position: relative;
  left: 0px;
}

.switch-father {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
}
</style>
